import React from 'react';
import { Breakpoint, Stack, Text } from '@moda/om';
import { OrderItem } from '../../../hooks/useOrder';
import { OrderDetailsShippingStatus } from '../../OrderDetailsMain/OrderDetailsItemsSections/OrderDetailsShippingStatus';

interface Props {
  item: OrderItem;
  showExtraDetails: boolean;
}

export const OrderItemDetails: React.FC<Props> = ({ item, showExtraDetails }) => (
  <Stack space={3}>
    <Stack space={0}>
      <Text treatment="bold1">{item.attributes.designerName}</Text>
      <Text>{item.attributes.details.name}</Text>
    </Stack>
    <Breakpoint gt="sm">
      <Stack space={3} direction="horizontal">
        <Stack space={1} direction="horizontal">
          <Text color="cement">Color:</Text>
          <Text>{item.attributes.color}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Size:&nbsp;</Text>
          <Text>{item.attributes.size}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Quantity:&nbsp;</Text>
          <Text>{item.attributes.quantity}</Text>
        </Stack>
      </Stack>
    </Breakpoint>

    <Breakpoint lt="sm">
      <Stack space={1}>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Color:</Text>
          <Text>{item.attributes.color}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Size:&nbsp;</Text>
          <Text>{item.attributes.size}</Text>
        </Stack>
        <Stack space={1} direction="horizontal">
          <Text color="cement">Quantity:&nbsp;</Text>
          <Text>{item.attributes.quantity}</Text>
        </Stack>
      </Stack>
    </Breakpoint>

    {showExtraDetails && (
      <>
        {item.attributes.excessShipping && <Text>{item.attributes.excessShipping}</Text>}

        {item.attributes.returnMessage && <Text>{item.attributes.returnMessage}</Text>}

        <OrderDetailsShippingStatus shippingStatus={item.attributes.shippingStatus} />

        {item.attributes.giftEligibility && <Text>{item.attributes.giftEligibility}</Text>}

        {item.attributes.promotionApplicableMessage && (
          <Text>{item.attributes.promotionApplicableMessage}</Text>
        )}

        {item.attributes.excludedFromRewards && <Text>{item.attributes.excludedFromRewards}</Text>}

        {item.attributes.customization && <Text>{item.attributes.customization}</Text>}
      </>
    )}
  </Stack>
);
